import { PlaceholdersId, TFComponent } from '@types';
import { ServiceErrorPlaceholder } from './serviceError';

export const serviceError: TFComponent = {
	component: ServiceErrorPlaceholder,
	id: PlaceholdersId.serviceError,
	name: 'serviceError',
};
